module.exports = __webpack_public_path__ + "img/yoyolumi.27e14fca.png";